import {
	Logos,
	MainFooter,
} from "pu-crossproduct-components/build/components/Organisms/HeadersFooters/MainFooter";
import { Link } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";

const Footer = styled.div`
  z-index: 5;
  background: #F9F9F9;
`;

export const InformatFooter: React.FC = (props) => {
	const { t } = useTranslation();

	return (
		<Footer>
			<MainFooter logo={Logos.plantyn}>
				<Link
					onClick={() =>
						window.open("https://www.plantyn.com/contact/", "_blank")
					}
				>
					<Trans t={t}>footerContact</Trans>
				</Link>
				<Link
					onClick={() =>
						window.open("https://www.plantyn.com/privacy", "_blank")
					}
				>
					<Trans t={t}>footerPrivacy</Trans>
				</Link>
				<Link
					onClick={() =>
						window.open(
							"https://www.plantyn.com/algemene-voorwaarden",
							"_blank",
						)
					}
				>
					<Trans t={t}>footerTermsConditions</Trans>
				</Link>
			</MainFooter>
		</Footer>
	);
};
